import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=36d25361&scoped=true&"
import script from "./DateComponent.vue?vue&type=script&lang=js&"
export * from "./DateComponent.vue?vue&type=script&lang=js&"
import style0 from "./DateComponent.vue?vue&type=style&index=0&id=36d25361&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d25361",
  null
  
)

export default component.exports